<template>
  <div class="peekai-nudge-banner">
    <div class="peekai-nudge-banner__logo">
      <img :src="require('@/assets/img/peekai/logo.svg?url')" alt="PeekAI" />
    </div>

    <!-- Step1: 초기 유도 -->
    <div v-if="step === 1" class="peekai-nudge-banner__body">
      <div class="peekai-nudge-banner__text">
        <p class="peekai-nudge-banner__text--sub">{{ $t('peekai.nudge.step1Sub') }}</p>
        <p class="peekai-nudge-banner__text--main">{{ $t('peekai.nudge.step1Main1') }}</p>
        <p class="peekai-nudge-banner__text--main">{{ $t('peekai.nudge.step1Main2') }}</p>
      </div>
      <button type="button" class="peekai-nudge-banner__btn" :disabled="disabled" @click="$emit('confirm')">
        <span>{{ $t('peekai.nudge.step1Btn') }}</span>
        <img
          class="peekai-nudge-banner__btn-icon"
          :src="require('@/assets/img/peekai/target.svg?url')"
          alt=""
        />
      </button>
    </div>

    <!-- Step2: 분석 중 -->
    <div v-else-if="step === 2" class="peekai-nudge-banner__body">
      <div class="peekai-nudge-banner__text">
        <p class="peekai-nudge-banner__text--sub">{{ $t('peekai.nudge.step2Sub') }}</p>
        <p class="peekai-nudge-banner__text--main">{{ $t('peekai.nudge.step2Main1') }}</p>
        <p class="peekai-nudge-banner__text--main">{{ $t('peekai.nudge.step2Main2') }}</p>
      </div>
      <div class="peekai-nudge-banner__progress">
        <div class="peekai-nudge-banner__progress-info">
          <span class="peekai-nudge-banner__progress-dot"></span>
          <span class="peekai-nudge-banner__progress-label">{{ progressLabel }}</span>
          <span class="peekai-nudge-banner__progress-count">{{ progressStep }} / 4</span>
        </div>
        <div
          class="peekai-nudge-banner__progress-bar"
          :class="`peekai-nudge-banner__progress-bar--${progressStep}`"
        >
          <span
            v-for="i in 4"
            :key="i"
            class="peekai-nudge-banner__progress-segment"
            :class="{ active: i <= progressStep }"
          ></span>
        </div>
      </div>
    </div>

    <!-- Step3: 결과 준비 완료 -->
    <div v-else-if="step === 3" class="peekai-nudge-banner__body">
      <div class="peekai-nudge-banner__text">
        <p class="peekai-nudge-banner__text--sub">{{ $t('peekai.nudge.step3Sub') }}</p>
        <p class="peekai-nudge-banner__text--main">{{ $t('peekai.nudge.step3Main1') }}</p>
        <p class="peekai-nudge-banner__text--main">{{ $t('peekai.nudge.step3Main2') }}</p>
      </div>
      <button type="button" class="peekai-nudge-banner__btn" :disabled="disabled" @click="$emit('view-report')">
        <span>{{ $t('peekai.nudge.step3Btn') }}</span>
        <img
          class="peekai-nudge-banner__btn-icon"
          :src="require('@/assets/img/peekai/arrow-right.svg?url')"
          alt=""
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PeekaiNudgeBanner',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 1,
      validator: v => [1, 2, 3].includes(v)
    },
    progressStep: {
      type: Number,
      default: 1,
      validator: v => v >= 1 && v <= 4
    }
  },
  data () {
    return {}
  },
  computed: {
    progressLabel () {
      const labels = {
        1: this.$t('peekai.nudge.progress1'),
        2: this.$t('peekai.nudge.progress2'),
        3: this.$t('peekai.nudge.progress3'),
        4: this.$t('peekai.nudge.progress4')
      }
      return labels[this.progressStep] || labels[1]
    }
  }
}
</script>

<style lang="scss" scoped>
.peekai-nudge-banner {
  width: 186px;
  height: 248px;
  background: #F4E43A;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;

  &__logo {
    flex-shrink: 0;
    width: 40px;
    height: 21px;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    min-height: 0;
    justify-content: space-between;
  }

  &__text {
    padding-top: 16px;

    &--sub {
      font-size: 14px;
      font-weight: 700;
      line-height: 1.3;
      letter-spacing: -0.35px;
      color: #000;
      margin: 0;
    }

    &--main {
      font-size: 24px;
      font-weight: 800;
      line-height: 1.3;
      letter-spacing: -0.6px;
      color: #000;
      margin: 0;
    }
  }

  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    height: 38px;
    min-width: 90px;
    padding: 0 18px;
    background: #0085FF;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    flex-shrink: 0;

    span {
      font-size: 14px;
      font-weight: 600;
      line-height: 1;
      color: #fff;
      white-space: nowrap;
    }

    &:hover {
      background: #0073E6;
    }
  }

  &__btn-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  &__progress {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 12px 8px;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  &__progress-info {
    display: flex;
    align-items: flex-start;
    gap: 0;
    width: 100%;
  }

  &__progress-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #000;
    margin-top: 4px;
    margin-right: 8px;
    flex-shrink: 0;
  }

  &__progress-label {
    flex: 1;
    min-width: 0;
    font-size: 11px;
    font-weight: 400;
    line-height: 1.3;
    letter-spacing: -0.275px;
    color: #000;
    white-space: pre-line;
  }

  &__progress-count {
    font-size: 11px;
    font-weight: 700;
    line-height: 1.3;
    color: #777;
    white-space: nowrap;
    flex-shrink: 0;
  }

  &__progress-bar {
    display: flex;
    gap: 4px;
    width: 100%;

    &--1 .peekai-nudge-banner__progress-segment.active::after {
      animation-name: peekai-shimmer-1;
      animation-duration: 1.5s;
    }

    &--2 .peekai-nudge-banner__progress-segment.active::after {
      animation-name: peekai-shimmer-2;
      animation-duration: 3s;
    }

    &--3 .peekai-nudge-banner__progress-segment.active::after {
      animation-name: peekai-shimmer-3;
      animation-duration: 4.5s;
    }

    &--4 .peekai-nudge-banner__progress-segment.active::after {
      animation-name: peekai-shimmer-4;
      animation-duration: 6s;
    }
  }

  &__progress-segment {
    flex: 1;
    height: 4px;
    border-radius: 2px;
    background: rgba(0, 0, 0, 0.25);

    &.active {
      position: relative;
      overflow: hidden;
      background: #0085FF;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: -10px;
        width: 10px;
        height: 100%;
        opacity: 0;
        background: linear-gradient(
          90deg,
          transparent 0%,
          rgba(255, 255, 255, 0.6) 50%,
          transparent 100%
        );
        animation-timing-function: linear;
        animation-iteration-count: infinite;
      }

      &:nth-child(1)::after {
        animation-delay: 0s;
      }

      &:nth-child(2)::after {
        animation-delay: 1.5s;
      }

      &:nth-child(3)::after {
        animation-delay: 3s;
      }

      &:nth-child(4)::after {
        animation-delay: 4.5s;
      }
    }
  }
}

@keyframes peekai-shimmer-1 {
  0% {
    left: -10px;
    opacity: 1;
  }
  100% {
    left: 100%;
    opacity: 1;
  }
}

@keyframes peekai-shimmer-2 {
  0% {
    left: -10px;
    opacity: 1;
  }
  50% {
    left: 100%;
    opacity: 1;
  }
  50.001%,
  100% {
    left: 100%;
    opacity: 0;
  }
}

@keyframes peekai-shimmer-3 {
  0% {
    left: -10px;
    opacity: 1;
  }
  33.333% {
    left: 100%;
    opacity: 1;
  }
  33.334%,
  100% {
    left: 100%;
    opacity: 0;
  }
}

@keyframes peekai-shimmer-4 {
  0% {
    left: -10px;
    opacity: 1;
  }
  25% {
    left: 100%;
    opacity: 1;
  }
  25.001%,
  100% {
    left: 100%;
    opacity: 0;
  }
}
</style>
